import {
  type EventInfo,
  type EventInfoApiResponse,
} from '~/features/common/types/common'
import { get } from '~/shared/http-client/api'

export const getOngoingEventInfo = async (): Promise<EventInfo> => {
  const response: EventInfoApiResponse = await get(`/main/ongoingEvent`)

  return response.data.eventInfo
}
